import revive_payload_client_4sVQNw7RlN from "/web/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/web/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/web/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/web/.nuxt/pwa-icons-plugin.ts";
import pwa_client_Eorgdr12jA from "/web/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import primevue_plugin_egKpok8Auk from "/web/.nuxt/primevue-plugin.mjs";
import plugin_client_8fz26Kfk5j from "/web/node_modules/nuxt-primevue/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/web/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import page_views_client_c62ZGst2KF from "/web/plugins/page-views.client.ts";
import theme_client_svVykVDRvQ from "/web/plugins/theme.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_Eorgdr12jA,
  primevue_plugin_egKpok8Auk,
  plugin_client_8fz26Kfk5j,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  page_views_client_c62ZGst2KF,
  theme_client_svVykVDRvQ
]